// import { getQueryKey } from '@trpc/react-query'
import { trpc } from 'api'
import AppConfig from 'config'
import { isEqual } from 'lodash'
import { useEffect } from 'react'
import useRemoteConfigParams from 'storage/useRemoteConfigParams'
import { useRemoteConfigStore } from './useRemoteConfigStore'
import { useCustomer, useStaff } from './useSession'
import useOfflineModal from './useOfflineModal'
import { RemoteConfig } from '@ca/common/types'

const useRemoteConfigQuery = () => {
  const params = useRemoteConfigParams((state) => state.params)
  const savedVersion = useRemoteConfigStore((state) => state.version)
  const savedConfig = useRemoteConfigStore((state) => state.config)
  const update = useRemoteConfigStore((state) => state.update)
  const updatedAt = useRemoteConfigStore((state) => state.updatedAt)

  const customer = useCustomer()
  const staff = useStaff()
  const offlineModal = useOfflineModal()

  const persisted =
    savedVersion < AppConfig.remoteConfig.version ? null : savedConfig

  const shouldRefetch = !customer && !staff

  const query = trpc.config.fetch.useQuery<RemoteConfig, RemoteConfig>(params, {
    initialData: () => persisted || undefined,
    initialDataUpdatedAt: updatedAt,
    placeholderData: (v) => v,

    refetchInterval: shouldRefetch
      ? AppConfig.remoteConfig.refetchInterval
      : false,
  })

  const { data, isError, isRefetchError, isLoadingError } = query

  const isErrors = isError || isRefetchError || isLoadingError

  useEffect(() => {
    if (data && !isEqual(data, persisted)) {
      update({
        config: data,
        version: AppConfig.remoteConfig.version,
      })
    }
  }, [data])

  useEffect(() => {
    if (!data && isErrors && !offlineModal.isOpen) {
      offlineModal.open()
    }

    if (data && !isErrors && offlineModal.isOpen) {
      offlineModal.close()
    }
  }, [isErrors, data])

  /*
  // Refetch interval while offline
  useEffect(() => {
    if (!isErrors) return

    const interval = setInterval(() => {
      console.log('⚠️ interval')
      if (isErrors) {
        console.log('✅ refetch')
        query.refetch()
      }
    }, 10 * 1000)

    return () => clearInterval(interval)
  }, [isErrors])
  */

  return query
}

export default useRemoteConfigQuery
